import { default as Container } from './GroupNotesToolbar.container';
import { default as Component } from './GroupNotesToolbar';
export default Container(Component);
